import $ from 'jquery'
import Backbone from 'backbone'
import MarkedField from 'scoreboard/components/marked-field'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import unwrapModel from 'scoreboard/components/unwrap-model'
import dropdown from 'scoreboard/components/dropdown'
import requiredValidator from 'scoreboard/components/validators/required-validator'

/**
 * @typedef IdAndTempId
 * @property {Integer} [id] - if persisted to the database, the ID
 * @property {String} [tempId] - if newly created, the tempId
 */

const SerieSelect = Backbone.View.extend({
	tagName: 'span',

	/**
	 * @type ChartDesigner
	 */
	model: null,

	/**
	 * Renders a dropdown to select a chart serie
	 *
	 * @param {String} [options.axis] 'left' or 'right'
	 *
	 * @param {Boolean} [options.includeAll=false] Add an all option at the
	 * beginning of the list.
	 *
	 * @param {Function} [options.filter] A predicate to further filter the options
	 *
	 * @param {IdAndTempId} [options.selected] the id/tempId of the initially
	 * selected serie
	 *
	 * @param {String} name - the value to be used for the select element's
	 * 'name' attribute
	 */
	initialize: function(options = {}) {
		this.options = options
	},

	render: function() {
		this.select = $(`<select name="${this.options.name}">`).appendTo(this.el)

		dropdown.idLabels(this.select, this.selectOptions(), toSelectId(this.options.selected))

		let validators = this.options.includeAll ? [] : [requiredValidator]

		this.markedField = new MarkedField({
			el: this.select,
			validators
		}).render()

		return this
	},

	selectOptions () {
		const { axis, includeAll, filter = _.constant(true) } = this.options
		const seriesOptions = []
		if (includeAll) {
			seriesOptions.push({ label: i18n.get('charts.series.all'), id: '' })
		}
		this.model.getFeatures({ type: 'serie', axis }).filter(filter).forEach(serieModel => {
			seriesOptions.push({
				label: this.model.featureLabel({ feature: serieModel }),
				id: toSelectId(serieModel)
			})
		})
		return seriesOptions
	},

	/**
	 * @returns {IdAndTempId}
	 */
	val: function () {
		return fromSelectId(this.select.val())
	},

	isAll: function() {
		return '' === this.select.val()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.markedField], 'remove')
	}
})

function toSelectId (serie) {
	if (!serie) {
		return ''
	}

	const {id, tempId} = unwrapModel(serie)
	return !!tempId ? `tempId-${tempId}` : `id-${id}`
}

function fromSelectId (id) {
	if (id) {
		if (id.startsWith('id-')){
			return { id: parseInt(id.replace('id-', '')) }
		} else if (id.startsWith('tempId-')){
			return { tempId: id.replace('tempId-', '') }
		}
	}
	return {}
}

SerieSelect.appendAndRender = function (appendTo, view) {
	appendTo.append(view.el)
	view.render()
	return view
}

export default SerieSelect

SerieSelect.__filename__ = 'charts/edit/serie-select.js'
